module.exports = __webpack_public_path__ + "img/logout.1c5dedf7.svg";